export const TEST_ID = 'subtitleText';
